import * as React from "react";
import DebitorFields from "../../../booking/Customer/DebitorFields";
import Customer from "../../../booking/Customer";
import { orderToOrderReceiptModel } from "../../../utils/emailHelper";
import { debitorFieldConfig, getCustomerValidation } from "../../../../util/validate";
import { getOrderPaymentTypeText } from "../../../utils/orderPaymentTypeHelper";
import WhoIsPaying from "../../../dashboard/WhoIsPaying";
import "../../../booking/Customer/style.css";
import "../../../dashboard/style.css";
import "../../style.css";
import {
    ActionButton,
    Stack,
    PrimaryButton,
    DefaultButton,
    Dropdown,
    IDropdownOption
} from "@fluentui/react";
import { useDispatch, useSelector } from "react-redux";
import { getAnydayQRCodes } from "../../../../state/department/anydayQRCode";
import { RootState } from "../../../../state";
import { getDepartments } from "../../../../state/action";
import api from "../../../../api";
import DropdownPanel from "../../../../components/base/DropdownPanel";
import { getAnydayOrder } from "../../../../state/order/action";
interface Props {
    order: Order;
    departments: Department[];
    leasers: Leaser[];
    insurers: Insurer[];
    car: Car;
    debitors?: Debitor[];
    updateCar: (car: Car) => void;
    whoIsPayingChange: (whoIsPaying: WhoIsPaying) => void;
    updateDebitorFromWhoIsPaying: (
        whoIsPaying: WhoIsPaying,
        order: Order,
        updatePrices: boolean
    ) => void;
    onDepartmentChange: (department: Department, shouldUpdateDebitor: boolean) => void;
    updateDebitor: (debitor: Partial<Debitor>) => void;
    updateCustomer: (customer: Partial<Customer>) => void;
    updateCustomerCityFromZipCode: (zipcode: string) => void;
    sendReceiptEmail: (model: IOrderReceiptModel) => void;
    getDebitor: (query: string, type: ApiType) => void;
    setDebitor: (debitor: Debitor) => void;
}

function Payment(props: Props) {
    const [enableEdit, toggleEdit] = React.useState(false);
    const [sent, toggleSent] = React.useState(false);

    const dispatch = useDispatch() as any;
    const departments = useSelector((state: RootState) => getDepartments(state));

    const departmentId = props.order.timeAndPlace.department && props.order.timeAndPlace.department.id&& props.order.timeAndPlace.department.id;

    const anydayQRCodes = React.useMemo(() => {
        if (!departmentId) return [];
        const department = departments.find(d => d.id === departmentId);

        if (department && department.anydayQRCodes) {
            return department.anydayQRCodes;
        }

        return [];
    }, [departments, departmentId]);

    const anydayOptions = React.useMemo<IDropdownOption[]>(() => {
        return anydayQRCodes
            .filter(x => !!x.qrCodeId)
            .map(x => ({
                key: x.id as string,
                text: x.name ? x.name : (x.qrCodeId as string)
            }));
    }, [anydayQRCodes]);

    const fetchAnyday = () =>{
         if (props.order.additionalData.whoIsPaying === "ANYDAY_CASH" && departmentId) {
            dispatch(getAnydayQRCodes(departmentId));
            dispatch(getAnydayOrder(props.order.additionalData.orderId as string));
        }
    }

    React.useEffect(() => fetchAnyday(), [departmentId,props.order.additionalData.orderId, props.order.additionalData.whoIsPaying]);

     const onPanelToggle = (open: boolean) => fetchAnyday();

    const [selectedAnydayQRCodeId, setSelectedAnydayQRCodeId] = React.useState<
        string | undefined
    >(undefined);

    React.useEffect(() => {
        if (!selectedAnydayQRCodeId && anydayOptions.length > 0) {
            setSelectedAnydayQRCodeId(anydayOptions[0].key as string);
        }
    }, [anydayOptions, selectedAnydayQRCodeId]);

    const handleEdit = () => toggleEdit(!enableEdit);

    const SendReceiptEmail = () => {
        const receiptModel = orderToOrderReceiptModel(props.order);
        props.sendReceiptEmail(receiptModel);
        toggleSent(true);
    };

    const openanyDayApp = async () => {
       var url = await api.AnydayApi.payment(props.order, selectedAnydayQRCodeId as string);
       window.location.href = url;
    };

  

    let anyDayView = null;
    console.log(props.order.OrderAnyday);
    if (props.order && props.order.additionalData.whoIsPaying === "ANYDAY_CASH") {
        var anydayStatus = null;
        if(props.order.OrderAnyday && props.order.OrderAnyday.status == "ACCEPTED")
        {
            anydayStatus = <Stack.Item><p style={{ color: "green", fontWeight: "bold" }}>Betaling modtaget via Anyday</p></Stack.Item>;
        }
        anyDayView = (
             <Stack horizontal tokens={{ childrenGap: 50 }}>
                 <Stack.Item grow={1}>  
                    <h4>Anyday betaling</h4>

                    <Dropdown style={{ marginBottom: "10px" }}
                        placeholder="Vælg QR kode"
                        options={anydayOptions}
                        selectedKey={selectedAnydayQRCodeId}
                        onChange={(_, option) => setSelectedAnydayQRCodeId(option ? (option.key as string) : undefined)}
                        disabled={anydayOptions.length === 0}
                    />

                    <DefaultButton
                        text="Åbn Anyday QR kode"
                        onClick={openanyDayApp}
                        disabled={!selectedAnydayQRCodeId}
                    />
                </Stack.Item>
                {anydayStatus}
            </Stack>
        );
    }

    return (
        <DropdownPanel onToggle={onPanelToggle} titleBackgroundColor={props.order.additionalData.whoIsPaying === "ANYDAY_CASH"? "mediumpurple": undefined} changed={false} title={"Betalingsinformation"}>
            <>
            <div className="payment__container">
                <ActionButton
                    data-automation-id="test"
                    iconProps={{
                        iconName: enableEdit ? "BoxCheckmarkSolid" : "Edit"
                    }}
                    onClick={handleEdit}
                ></ActionButton>

                {enableEdit ? (
                    <WhoIsPaying
                        departments={props.departments}
                        onDepartmentChange={props.onDepartmentChange}
                        updateDebitorFromWhoIsPaying={props.updateDebitorFromWhoIsPaying}
                        order={props.order}
                        car={props.car}
                        updateCar={props.updateCar}
                        leasers={props.leasers}
                        insurers={props.insurers}
                        debitors={props.debitors}
                        getDebitor={props.getDebitor}
                        onDebitorChange={props.setDebitor}
                        selectedDebitor={props.order.debitor}
                    />
                ) : (
                    <>
                        <h5 style={{ marginRight: "10px" }}>Hvem betaler</h5>
                        <p style={{ marginRight: "20px" }}>
                            {getOrderPaymentTypeText(props.order.additionalData.whoIsPaying)}
                        </p>
                    </>
                )}

                {anyDayView}
            </div>

            <div className="styled_customer__form">
                <Stack horizontal tokens={{ childrenGap: 50 }}>
                    <Stack.Item grow={1}>
                        <DebitorFields
                            fieldConfig={debitorFieldConfig}
                            debitor={props.order.debitor}
                            updateDebitor={props.updateDebitor}
                        />
                    </Stack.Item>
                    <Stack.Item grow={1}>
                        <div className="customer__paymentForm">
                            <Customer
                                fieldConfig={getCustomerValidation(
                                    props.order.additionalData.whoIsPaying
                                )}
                                customer={props.order.customer}
                                updateCustomer={props.updateCustomer}
                                updateCustomerCityFromZipCode={props.updateCustomerCityFromZipCode}
                            />
                        </div>
                        {props.order.customer.allowEmail ? (
                            props.order.additionalData.whoIsPaying === "CASH" ? (
                                <PrimaryButton
                                    text={!sent ? "Send kvitteringsmail" : "Kvitteringsmail afstendt"}
                                    className="receipt-button"
                                    disabled={sent}
                                    onClick={SendReceiptEmail}
                                />
                            ) : null
                        ) : (
                            <>
                                <div className="cancel--inline disabled cancel_button">
                                    <PrimaryButton disabled text="EMAIL ikke tilladt" />
                                </div>
                            </>
                        )}
                    </Stack.Item>
                </Stack>
            </div>
            </>
        </DropdownPanel>
    );
}

export default Payment;